'use client';


import Icon from '@/components/ui/AppIcon';

interface AuthTabsProps {
  activeTab: 'login' | 'register';
  onTabChange: (tab: 'login' | 'register') => void;
}

const AuthTabs = ({ activeTab, onTabChange }: AuthTabsProps) => {
  return (
    <div data-component-id="src/app/authentication-portal/components/AuthTabs.tsx:13:4" data-component-path="src/app/authentication-portal/components/AuthTabs.tsx" data-component-line="13" data-component-file="AuthTabs.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-2%20p-1%20bg-muted%2F30%20rounded-lg%20mb-6%22%7D" className="flex gap-2 p-1 bg-muted/30 rounded-lg mb-6">
      <button data-component-id="src/app/authentication-portal/components/AuthTabs.tsx:14:6" data-component-path="src/app/authentication-portal/components/AuthTabs.tsx" data-component-line="14" data-component-file="AuthTabs.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22Sign%20In%22%7D"
        onClick={() => onTabChange('login')}
        className={`
          flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md
          text-sm font-medium transition-all duration-200
          ${
            activeTab === 'login' ?'bg-surface text-foreground shadow-elevation-1' :'text-muted-foreground hover:text-foreground'
          }
        `}
      >
        <Icon data-component-id="src/app/authentication-portal/components/AuthTabs.tsx:24:8" data-component-path="src/app/authentication-portal/components/AuthTabs.tsx" data-component-line="24" data-component-file="AuthTabs.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightOnRectangleIcon%22%7D" name="ArrowRightOnRectangleIcon" size={18} />
        Sign In
      </button>
      <button data-component-id="src/app/authentication-portal/components/AuthTabs.tsx:27:6" data-component-path="src/app/authentication-portal/components/AuthTabs.tsx" data-component-line="27" data-component-file="AuthTabs.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22Register%22%7D"
        onClick={() => onTabChange('register')}
        className={`
          flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-md
          text-sm font-medium transition-all duration-200
          ${
            activeTab === 'register' ?'bg-surface text-foreground shadow-elevation-1' :'text-muted-foreground hover:text-foreground'
          }
        `}
      >
        <Icon data-component-id="src/app/authentication-portal/components/AuthTabs.tsx:37:8" data-component-path="src/app/authentication-portal/components/AuthTabs.tsx" data-component-line="37" data-component-file="AuthTabs.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22UserPlusIcon%22%7D" name="UserPlusIcon" size={18} />
        Register
      </button>
    </div>
  );
};

export default AuthTabs;